import {Component} from '@angular/core';

@Component({
  selector: 'gd-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})
export class TabsComponent {
  constructor() {
  }

}
